module.exports = __webpack_public_path__ + "img/donante-ken-jewish.da179221.png";